import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Flex, Spin, Select } from "antd";
import axios from "axios";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Option } = Select;

const Profile = ({ showModal, closeModal, updateUser }) => {
  const [loading, setLoading] = useState(false);
  const [base64Image, setBase64Image] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("KG");
  const [phoneInputValue, setPhoneInputValue] = useState("");
  const user = useSelector((state) => state.auth.user);
  const [profile, setProfile] = useState(null);

  const countries = [
    { code: "KG", flag: "🇰🇬", prefix: "+996", format: "xxx xx-xx-xx" },
    { code: "KZ", flag: "🇰🇿", prefix: "+7", format: "xxx xxx-xx-xx" },
    { code: "UZ", flag: "🇺🇿", prefix: "+998", format: "xx xxx-xx-xx" },
    { code: "RU", flag: "🇷🇺", prefix: "+7", format: "xxx xxx-xx-xx" },
    { code: "BY", flag: "🇧🇾", prefix: "+375", format: "xx xxx-xx-xx" },
  ];

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
  };

  const handlePhoneInputChange = (e) => {
    setPhoneInputValue(e.target.value);
  };

  const [form] = Form.useForm();

  useEffect(() => {
    if (user) {
      fetchProfile(user);
      form.setFieldsValue(user);

      // Extract country code from phone number and set phone input value
      if (user.phone_number) {
        const phoneNumber = user.phone_number.toString();
        // Determine country based on phone number prefix
        if (phoneNumber.startsWith("996")) {
          setSelectedCountry("KG");
          setPhoneInputValue(phoneNumber.substring(3));
        } else if (phoneNumber.startsWith("7")) {
          setSelectedCountry("KZ");
          setPhoneInputValue(phoneNumber.substring(1));
        } else if (phoneNumber.startsWith("998")) {
          setSelectedCountry("UZ");
          setPhoneInputValue(phoneNumber.substring(3));
        } else if (phoneNumber.startsWith("375")) {
          setSelectedCountry("BY");
          setPhoneInputValue(phoneNumber.substring(3));
        } else {
          setSelectedCountry("KG");
          setPhoneInputValue(phoneNumber);
        }
      }

      // Set avatar if it exists in profile
      if (user.avatar && user.avatar.match(/\/media\//) !== null) {
        setBase64Image(user.avatar);
      }
    }
  }, [user]);

  // Close modal on route change
  useEffect(() => {
    if (!showModal) return;

    const currentPathname = window.location.pathname;

    const checkRouteChange = () => {
      if (window.location.pathname !== currentPathname) {
        closeModal();
      }
    };

    // Check for route changes periodically
    const intervalId = setInterval(checkRouteChange, 100);

    return () => {
      clearInterval(intervalId);
    };
  }, [showModal, closeModal]);

  const handleCancel = () => {
    closeModal();
  };

  const onFinishFailed = () => {
    console.log("Failed");
  };

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      await form.validateFields();

      // Get country prefix without + symbol
      const country = countries.find((c) => c.code === selectedCountry);
      const countryPrefix = country.prefix.replace("+", "");

      // Combine country code with phone number (remove any existing country code)
      const phoneDigits = phoneInputValue.replace(/\D/g, "");
      const phoneWithCountryCode = countryPrefix + phoneDigits;

      // Create payload without phone_number field from form values
      const { phone_number, ...formValuesWithoutPhone } = values;
      const payload = {
        ...formValuesWithoutPhone,
        phone_number: phoneWithCountryCode,
      };

      // if (!base64Image) {
      //   delete payload.avatar;
      // } else {
      //   payload.avatar = base64Image;
      // }

      delete payload.avatar;

      delete payload.whatsapp_number;
      delete payload.telegram_nickname;

      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/auth/users/${user.id}/`,
        method: "PATCH",
        headers: {
          Authorization: `JWT ${window.localStorage.getItem("access")}`,
        },
        data: payload,
      });

      const url = profile
        ? `${process.env.REACT_APP_API_URL}/auth/profile/${profile.id}/`
        : `${process.env.REACT_APP_API_URL}/auth/profile/`;

      const response2 = await axios({
        url,
        method: profile ? "PATCH" : "POST",
        headers: {
          Authorization: `JWT ${window.localStorage.getItem("access")}`,
        },
        data: {
          whatsapp_number: values.whatsapp_number,
          telegram_nickname: values.telegram_nickname,
        },
      });

      if (response.status === 200 && response2.status === 200) {
        updateUser(response.data);
        closeModal();
      }
    } catch (error) {
      console.log("Validation failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProfile = async (user) => {
    try {
      const { data, status } = await axios.get(
        `${process.env.REACT_APP_API_URL}/auth/profile/`,
        {
          headers: {
            Authorization: `JWT ${window.localStorage.getItem("access")}`,
          },
        },
      );
      console.log("status", status);
      if (status === 200) {
        const _profile = data.find((p) => p.user.id === user.id);
        setProfile(_profile);
        console.log("_profile", _profile);
        form.setFieldsValue({
          whatsapp_number: _profile.whatsapp_number,
          telegram_nickname: _profile.telegram_nickname,
        });
      }
    } catch (error) {
      console.error("Error fetching profile details:", error);
    }
  };

  // Convert file to base64
  const getBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(file);
  };

  return (
    <Modal
      title="Мой профиль"
      closable={{ "aria-label": "Custom Close Button" }}
      open={showModal}
      footer={null}
      onCancel={handleCancel}
      classNames={{ mask: "company-profile-modal-mask" }}
      maskClosable={false}
    >
      {loading && (
        <div className="transport-search-full-screen">
          <Flex align="center" gap="middle">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
            />
          </Flex>
        </div>
      )}
      <div className="profile">
        <Form
          form={form}
          className="profile-form-form"
          name="profile"
          layout="vertical"
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Логин"
            name="username"
            className="non-floating-form-item"
            rules={[
              {
                required: true,
                message: "Обязательное поле",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Имя"
            name="first_name"
            className="non-floating-form-item"
            rules={[
              {
                required: true,
                message: "Обязательное поле",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Фамилия"
            name="last_name"
            className="non-floating-form-item"
            rules={[
              {
                required: true,
                message: "Обязательное поле",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            className="non-floating-form-item"
            rules={[
              {
                type: "email",
                message: "Введите правильный email",
              },
              {
                required: true,
                message: "Обязательное поле",
              },
            ]}
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Номер телефона"
            className="non-floating-form-item profile-phone-form-item"
            rules={[
              {
                required: true,
                message: "Обязательное поле",
              },
            ]}
          >
            <Input
              placeholder="Введите номер телефона"
              value={phoneInputValue}
              onChange={handlePhoneInputChange}
              size="large"
              addonBefore={
                <Select
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  style={{ width: 120 }}
                >
                  {countries.map((country) => (
                    <Option key={country.code} value={country.code}>
                      {country.flag} {country.prefix}
                    </Option>
                  ))}
                </Select>
              }
            />
          </Form.Item>
          <Form.Item
            label="Номер whatsapp"
            name="whatsapp_number"
            className="non-floating-form-item"
          >
            <Input placeholder="" />
          </Form.Item>
          <Form.Item
            label="Телеграм"
            name="telegram_nickname"
            className="non-floating-form-item"
          >
            <Input placeholder="" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Сохранить
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default Profile;
